// Device-flow entry (/activate — RFC 8628 verification_uri). Tenant-agnostic
// twin of OAuthAuthorizePage: an authenticated user is forwarded to their own
// tenant's activation screen with the ?user_code intact; an unauthenticated
// user is parked into the SAME pending-key MultiTenantSignIn already resumes.
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { fetchSession } from '@/lib/session';
import { PENDING_AUTHORIZE_KEY, storedTenantSlug } from './OAuthAuthorizePage';

export const DeviceActivatePage: React.FC = () => {
  const { search } = useLocation();
  // Auth is now confirmed by the httpOnly session cookie via the gateway, so the
  // decision is async: 'checking' until the session probe resolves. (The legacy
  // token gate always saw null post-migration and wrongly bounced to login.)
  const [state, setState] = useState<{ status: 'checking' | 'authed' | 'anon'; slug: string | null }>({
    status: 'checking',
    slug: null,
  });

  useEffect(() => {
    let active = true;
    (async () => {
      const user = await fetchSession();
      if (!active) return;
      const slug = storedTenantSlug();
      setState(user && slug ? { status: 'authed', slug } : { status: 'anon', slug: null });
    })();
    return () => {
      active = false;
    };
  }, []);

  if (state.status === 'checking') return null;

  if (state.status === 'authed' && state.slug) {
    sessionStorage.removeItem(PENDING_AUTHORIZE_KEY);
    return <Navigate to={`/t/${state.slug}/app/oauth/activate${search}`} replace />;
  }

  try {
    sessionStorage.setItem(PENDING_AUTHORIZE_KEY, `/activate${search}`);
  } catch {
    // storage unavailable — login still works; the user retypes the code
  }
  return <Navigate to="/login" replace />;
};

export default DeviceActivatePage;
